export function getComplexTableFieldValue(fieldName: string, row: any) {
    if (!row) return null;

    let cellValue = row[fieldName];

    if (cellValue === null || cellValue === undefined) {
        const splitFieldName = fieldName.split(".");

        if (splitFieldName.length > 1) {
            try {
                let tmp = row;
                splitFieldName.forEach((n: string) => {
                    tmp = tmp[n];
                });

                cellValue = tmp;
            } catch (error) {
                //
            }
        }
    }

    return cellValue;
}
